// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"153":"34dbf3c0","260":"e8e0af4b","668":"0a8f54c6","762":"d1f173fc"}[chunkId] + ".js";
};